module.exports = __webpack_public_path__ + "media/assets/images/flags/dz-4a55405c1e1001bd03f6df25f04a852d.svg";